export const reactors = store => store.processbuilderReducer.reactors;
export const errors = store => store.processbuilderReducer.errors;
export const warnings = store => store.processbuilderReducer.warnings;
export const pumpsTypes = store => store.processbuilderReducer.pumpsTypes;
